/* @ngInject */
export const nospace = () => {
  return (value) => {
    return (!value) ? value : value.toString().replace(/ /g, '');
  }
}

export const noSpecialChar = () => {
  return (value) => {
    return (!value) ? value : value.toString().replace(/ |-/g, '');
  }
}



// WEBPACK FOOTER //
// ./public/javascript/sygem/global/services/filters/utils/nospace.filter.js